import { Button } from '@latitude/button';
import { Card } from '@latitude/card';
import { PortoLogoIcon } from '@latitude/icons';
import { Separator } from '@latitude/separator';
import { Text } from '@latitude/text';
import Image from 'next/image';
import { PORTO_ONBOARDING_SCHEDULE_URL, REGISTRATION_COMPLETE_CARDS } from '../../constants';
import RegistrationCompleteIllustration from '../../images/registration-complete.svg';
import { NextSteps } from './NextSteps';
const RegistrationCompletePage = () => {
  return <div className="flex flex-col size-full p-6 sm:px-10 lg:pt-9 overflow-y-scroll" data-sentry-component="RegistrationCompletePage" data-sentry-source-file="RegistrationCompletePage.tsx">
      <PortoLogoIcon className="h-11 shrink-0 self-start" data-sentry-element="PortoLogoIcon" data-sentry-source-file="RegistrationCompletePage.tsx" />
      <div className="max-w-[1120px] mx-auto my-4 sm:my-auto lg:my-20 flex flex-col gap-16 justify-center lg:justify-normal">
        <div className="min-w-0 grid content-center [grid-template-areas:'image''title''description'] lg:[grid-template-areas:'title_image''description_image'] gap-4 sm:gap-8 lg:gap-x-[120px] lg:gap-y-4">
          <Text variant="metricHuge" className="[grid-area:title]" data-sentry-element="Text" data-sentry-source-file="RegistrationCompletePage.tsx">
            Registration complete
          </Text>
          <div className="[grid-area:description] min-w-0">
            <Text variant="bodyRegular" className="mb-6" data-sentry-element="Text" data-sentry-source-file="RegistrationCompletePage.tsx">
              Thanks for signing up for Porto, Anchorage Digital&apos;s
              institutional grade self-custody wallet. We&apos;re pleased to
              welcome you to the platform and ask that you{' '}
              <Text asChild variant="link" className="text-color-ref-text-link-primary" data-sentry-element="Text" data-sentry-source-file="RegistrationCompletePage.tsx">
                <a href={PORTO_ONBOARDING_SCHEDULE_URL} target="_blank" rel="noopener noreferrer" className="hover:text-color-ref-text-strong">
                  schedule a call with our onboarding team
                </a>
              </Text>{' '}
              to get your account activated.
            </Text>
            <NextSteps data-sentry-element="NextSteps" data-sentry-source-file="RegistrationCompletePage.tsx" />
          </div>
          <Image loading="eager" src={RegistrationCompleteIllustration} width={280} alt="illustration" className="[grid-area:image] hidden sm:block justify-self-center" data-sentry-element="Image" data-sentry-source-file="RegistrationCompletePage.tsx" />
        </div>
        <Separator className="hidden lg:block" data-sentry-element="Separator" data-sentry-source-file="RegistrationCompletePage.tsx" />
        <div className="hidden lg:flex flex-col w-full gap-5">
          <Text variant="headingMedium" data-sentry-element="Text" data-sentry-source-file="RegistrationCompletePage.tsx">In the meantime...</Text>
          <div className="grid grid-cols-3 gap-5">
            {REGISTRATION_COMPLETE_CARDS.map(({
            title,
            content,
            url
          }) => <Card key={`registration-complete-card-${title}`} className="min-h-[281px] px-6 py-8 text-color-ref-text-strong">
                <div className="h-full flex flex-col justify-between gap-6">
                  <div className="flex flex-col gap-2">
                    <Text variant="headingSmall">{title}</Text>
                    <Text variant="bodyRegular">{content}</Text>
                  </div>
                  <a href={url} target="_blank" rel="noopener noreferrer">
                    <Button variant="neutral" type="outline" size="small">
                      Learn more
                    </Button>
                  </a>
                </div>
              </Card>)}
          </div>
        </div>
      </div>
    </div>;
};
export { RegistrationCompletePage };